module.exports = __webpack_public_path__ + "static/media/arsenal.87f4b889.svg";